import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import TopicCard, { ViewMoreTopicsCard } from './TopicCard'
import { Topic as ITopic } from '../../../../types/academy'

const useStyles = makeStyles((theme) => ({
  gridItem: {
    [theme.breakpoints.up('md')]: {
      flexGrow: 0,
      maxWidth: '20%',
      flexBasis: '25%',
    },
  },
}))

interface Props {
  topics: ITopic[]
}

function TopicGrid({ topics }: Props): JSX.Element {
  const classes = useStyles({})
  return (
    <Grid container justify="flex-start" spacing={2}>
      {topics.map((topic) => (
        <Grid item key={topic._id} xs={6} md={3} sm={4}>
          <TopicCard topic={topic} />
        </Grid>
      ))}
    </Grid>
  )
}

export default TopicGrid
